import { PRICE_DISPLAY_QUANTITY_SET } from '../constants';

const DEFAULT_STATE = {
  quantity: 1,
};

export const priceDisplayQuantity = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case PRICE_DISPLAY_QUANTITY_SET:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
